import { NgModule } from '@angular/core';
import { OrderByPipe } from '@core/pipes/order-by/order-by.pipe';

@NgModule({
    declarations: [
        OrderByPipe
    ],
    exports     : [
        OrderByPipe
    ]
})
export class OrderByPipeModule
{
}
